module.exports = __webpack_public_path__ + "img/Recover.5173ebf2.png";